module.exports = __webpack_public_path__ + "media/images/monitor_secas_logo-a771a1abb4ac93df74cd99db826fb5eb.png";